import React from "react";

const feeders = [
  {
    id: 1,
    title: "Band A Feeders in Edo State",
    image: "/images/Edo-bandA.jpg",
  },
  {
    id: 2,
    title: "Band A Feeders in Delta State",
    image: "/images/Delta-bandA.jpg",
  },
  {
    id: 3,
    title: "Band A Feeders in Ondo State",
    image: "/images/Ondo-bandA.jpg",
  },
  {
    id: 4,
    title: "Band A Feeders in Ekiti State",
    image: "/images/Ekiti-bandA.jpg",
  },
];

const BandAFeeders = () => {
  return (
    <div className="w-full bg-white font-sans">
      {/* Hero Section */} 
      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
              Band A <span className="text-yellow-400">Feeders</span>
              </h1>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
              <p className="text-white opacity-80 text-sm sm:text-base md:text-lg font-medium">Detailed list of premium feeders across our coverage states.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Feeders Grid */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8">
        <div className="bg-white rounded-xl md:rounded-2xl overflow-hidden shadow-xl border border-gray-100 mb-6">
            <object width="100%" height="600" data="/file/BAND A FEEDERS.pdf" type="application/pdf" className="w-full">
              <div className="p-10 text-center">
                <p className="text-sm sm:text-base font-bold mb-4">PDF viewing not supported by your browser.</p>
                <a
                  href="/file/BAND A FEEDERS.pdf"
                  download
                  className="bg-green-700 text-white px-6 py-3 rounded-xl font-black uppercase tracking-widest text-[10px] sm:text-xs inline-block shadow-lg hover:bg-black transition-all"
                >
                  Download PDF Instead
                </a>
              </div>
            </object>
        </div>

        <div className="p-6 sm:p-8 bg-black text-white rounded-xl md:rounded-2xl shadow-xl text-center relative overflow-hidden group">
          <div className="absolute inset-0 bg-green-700/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
          <p className="text-xs sm:text-sm md:text-base font-black uppercase tracking-widest italic relative z-10 leading-relaxed">
            "Ensuring 20-24 hours of guaranteed power supply to our premium Band A customers."
          </p>
        </div>
      </div>
    </div>
  );
};

export default BandAFeeders;